export default __webpack_public_path__ + "static/media/190629_201216_PHOTO-2018-05-17-17-40-10.929f3cf3.jpg";